import React from "react";

export default function ListBanner(props) {
    let { data } = props;

    return (
        <div className="widget-lister__list-banner">
            {data.image && data.url && (
                <div className="list-banner--full">
                    <div className="book-banner">
                        <a href={data.url} className="book-banner-link">
                            <img src={data.image} alt="Banner image" />
                        </a>
                        <div className="book-banner-text">
                            <h2 className="book-banner-title">{data.title}</h2>
                            <h3 className="book-banner-subtitle">{data.lead}</h3>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
